// Copyright (C) 2023 Cochise Ruhulessin
//
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
import { useEffect } from "react"
import { SectionPage } from "../../../lib"
import { getCurrentAccountId, getLastUsedAccountId } from "../lib"


interface ConsoleSectionPageProps extends React.ComponentProps<typeof SectionPage> {
  children: React.ReactNode
  noRedirect?: boolean
}


const ConsoleSectionPage: React.FC<ConsoleSectionPageProps> = ({
  children,
  noRedirect,
  ...props
}) => {
  const currentAccountId = getCurrentAccountId()
  const lastUsedAccountId = getLastUsedAccountId()
  const mustRedirect = !currentAccountId
    && !noRedirect
    && lastUsedAccountId

  useEffect(() => {
    if (mustRedirect) {
      const url = new URL(window.location.href)
      url.searchParams.set("rlm", lastUsedAccountId.toString())
      window.location.href = url.toString()
    }
  })

  if (mustRedirect) { return null }
  return (<SectionPage {...props}>{children}</SectionPage>)
}

export default ConsoleSectionPage